<template>
  <div
    class="flex w-full flex-col items-start space-y-2 text-xs sm:flex-row sm:items-center sm:space-y-0 sm:space-x-2"
  >
    <div class="whitespace-nowrap">Filtros ativos:</div>
    <div class="relative flex w-full max-w-full items-center overflow-hidden">
      <div
        class="scrollbar-hide scroll-container relative hidden items-center overflow-x-auto sm:flex"
        id="scroll-container"
      >
        <div
          v-for="filter in filtersToShow"
          :key="filter.name"
          class="hidden items-center first:ml-0 sm:flex sm:first:ml-8"
        >
          <template v-if="['tagbox', 'select'].includes(filter.type)">
            <button
              v-for="active in filter.active"
              :key="active"
              class="bg-ontick-green-600 text-ontick-carbon-900 ml-2 flex items-center space-x-2 whitespace-nowrap rounded-full px-2 py-1 font-semibold"
            >
              <span>
                {{
                  `${filter.name}: ${
                    filter.items.find((item) => active.includes(item.value))
                      .displayName
                  }`
                }}
              </span>
              <button @click="clearFilter(filter, active)">
                <i v-html="$icons.close_sm"></i>
              </button>
            </button>
          </template>
          <template v-else-if="filter.type === 'range'">
            <div
              class="bg-ontick-green-600 text-ontick-carbon-900 ml-2 flex items-center space-x-2 whitespace-nowrap rounded-full px-2 py-1 font-semibold"
            >
              <span>
                {{ `${filter.name}: ${filter.from} - ${filter.to}` }}
              </span>
              <button @click="clearFilter(filter)">
                <i v-html="$icons.close_sm"></i>
              </button>
            </div>
          </template>
        </div>
      </div>

      <!-- MOBILE -->
      <div
        class="scrollbar-hide relative flex w-full items-center overflow-x-scroll sm:hidden"
      >
        <div
          v-for="filter in filtersToShow"
          :key="filter.name"
          class="flex items-center last:mr-8"
        >
          <template v-if="['tagbox', 'select'].includes(filter.type)">
            <div
              v-for="active in filter.active"
              :key="active"
              class="bg-ontick-green-600 text-ontick-carbon-900 ml-2 flex items-center space-x-2 whitespace-nowrap rounded-full px-2 py-1 font-semibold"
            >
              <span>
                {{
                  `${filter.name}: ${
                    filter.items.find((item) => active.includes(item.value))
                      .displayName
                  }`
                }}
              </span>
              <button @click="clearFilter(filter, active)">
                <i v-html="$icons.close_sm"></i>
              </button>
            </div>
          </template>
          <div
            v-else-if="filter.type === 'range'"
            class="bg-ontick-green-600 text-ontick-carbon-900 ml-2 flex items-center space-x-2 whitespace-nowrap rounded-full px-2 py-1 font-semibold"
          >
            <span>
              {{ `${filter.name}: ${filter.from} - ${filter.to}` }}
            </span>
            <button @click="clearFilter(filter)">
              <i v-html="$icons.close_sm"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="dark:to-ontick-carbon-500 pointer-events-none absolute left-0 hidden h-full w-8 bg-gradient-to-l from-transparent to-gray-50 sm:absolute"
      ></div>
      <div
        class="dark:to-ontick-carbon-500 pointer-events-none absolute right-0 h-full w-8 bg-gradient-to-r from-transparent to-gray-50"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      activeFilters: "marketplace/getActiveFilters",
      filters: "marketplace/getFilters",
    }),
    filtersToShow() {
      return this.filters.filter((filter) =>
        this.activeFilters
          .map((activeFilter) => activeFilter.name)
          .includes(filter.slug)
      );
    },
  },

  methods: {
    ...mapActions({ clearFilter: "marketplace/clearFilter" }),
  },

  mounted() {
    const ele = document.getElementById("scroll-container");
    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {
      console.log(e);
      // Change the cursor and prevent user from selecting the text
      ele.style.cursor = "grabbing";
      ele.style.userSelect = "none";
      pos = {
        // The current scroll
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    };
    const mouseUpHandler = function () {
      document.removeEventListener("mousemove", mouseMoveHandler);
      document.removeEventListener("mouseup", mouseUpHandler);

      ele.style.cursor = "grab";
      ele.style.removeProperty("user-select");
    };
    const mouseMoveHandler = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      // Scroll the element
      ele.scrollTop = pos.top - dy;
      ele.scrollLeft = pos.left - dx;
    };
    ele.addEventListener("mousedown", mouseDownHandler);
  },
};
</script>

<style scoped>
/* For Webkit-based browsers (Chrome, Safari and Opera) */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
